import { getHttp } from './fetchApi';

export const Customers = {
    URL: '/customers.json',
    getAll(){
        return getHttp(this.URL)
    },

}
